import { Box, Stack, Typography } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";

const NoGapRule = () => {
  return (
    <>
      <Box
        sx={{
          border: "1px solid #2E7D3280",
          borderRadius: "8px",
          backgroundColor: "#2E7D320A",
          p: 1,
        }}
      >
        <Stack direction="row" alignItems="center" spacing={1} mb={1}>
          <CheckIcon
            sx={{
              color: "#1B5E20",
              fontSize: 18,
            }}
          />

          <Typography
            sx={{
              color: "#1B5E20",
              fontSize: "14px",
              fontWeight: 500,
              textTransform: "uppercase",
              letterSpacing: "0.5px",
            }}
          >
            no gap rule
          </Typography>
        </Stack>

        <Typography
          sx={{
            color: "#1B5E20",
            fontSize: "14px",
            lineHeight: "20px",
          }}
        >
          This field passes through directly from the unifier. No business logic
          transformation was applied by the business adviser for this brand.
        </Typography>
      </Box>
    </>
  );
};

export default NoGapRule;
